"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApTextInput = void 0;
var React = require("react");
var defaultTextInput_1 = require("../../common/defaultTextInput");
var types_1 = require("../../utils/types");
var styles_1 = require("./styles");
exports.ApTextInput = React.forwardRef(function (_a, ref) {
    var id = _a.id, className = _a.className, theme = _a.theme, left = _a.left, right = _a.right, props = __rest(_a, ["id", "className", "theme", "left", "right"]);
    return (React.createElement(styles_1.StyledTextLabel, { title: id, htmlFor: id },
        left && React.createElement(styles_1.StyledLeftChild, null, left()),
        React.createElement(defaultTextInput_1.StyledDefaultTextInput, __assign({}, props, { id: id, tabIndex: 0, autoComplete: "off", className: "ap-text-input " + (className ? className : ''), theme: theme, ref: ref })),
        right && React.createElement(styles_1.StyledRightChild, null, right())));
});
exports.ApTextInput.defaultProps = {
    autoFocus: false,
    disabled: false,
    theme: types_1.LIGHT,
};
//# sourceMappingURL=ApTextInput.js.map